// extracted by mini-css-extract-plugin
module.exports = {"header":"rankItem_header__2mEBi"};